import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserTypeAPI } from "../../enterpriseApi";
import { GetEnterPriseCompanyListAPI, getUserIdDetailsHelperAPI, PatchOnboardingAPI, postDeleteAccountApi, postOnboardingApi, postOnboardingCreateCardApi, postOnboardingCreateProfessionalCardApi, postOnboardingCreateStudentCardApi, postResumePraisingAPIHelper, postRevokeAccountApi } from "../helpers/OnboardingHelperApis";
import { data } from "currency-codes";

const initialState = {
    onboardingData: {},
    deleteAccount: {},
    revokeAccount: {},
    companies:[],
    deeplinkURL:"",
    userTypeDetails:{}
};

export const postOnboardingReducer = createAsyncThunk('/postOnboardingReducer', async (formData, thunkAPI) => {
    try {
        const response = await postOnboardingApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postDeleteAccountReducer = createAsyncThunk('/deleteAccount', async (data, thunkAPI) => {
    try {
        const response = await postDeleteAccountApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postRevokeAccountReducer = createAsyncThunk('/revokeAccount', async (data, thunkAPI) => {
    try {
        const response = await postRevokeAccountApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postOnboardingCreateProfessionalCardReducer = createAsyncThunk('/createProfessionalonboardingcard', async (data, thunkAPI) => {
    try {
        const response = await postOnboardingCreateProfessionalCardApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const postOnboardingCreateStudentCardReducer = createAsyncThunk('/createStudentonboardingcard', async (data, thunkAPI) => {
    try {
        const response = await postOnboardingCreateStudentCardApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const patchOnboardingReducer = createAsyncThunk('/patchonboarding', async (formdata, thunkAPI) => {
    try {
        const response = PatchOnboardingAPI(formdata);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})


export const GetEnterpriseCompanyList = createAsyncThunk('/getenterprisecompanyList', async (_, thunkAPI) => {
    try {
        const response = GetEnterPriseCompanyListAPI();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postResumePraising  = createAsyncThunk('/postResumeReducer', async (formData, thunkAPI) => {
    try {
        const response = await postResumePraisingAPIHelper(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})


export const getUserIdDetails = createAsyncThunk('/get-user-type', async (userId, thunkAPI) => {
    try {
        const response = await getUserTypeAPI();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message || error);
    }
})

export const getUserType = getUserIdDetails;



const OnboardingSlice = createSlice({
    name: 'Onboarding',
    initialState,
    reducers: {
        setDeeplinking: (state, action) => {
            state.deeplinkURL = action.payload
            
        },
        clearOnboarding: (state) => {
            state.onboardingData = {};
        },
    },

    extraReducers: (builder) => {
        builder.addCase(postOnboardingReducer.fulfilled, (state, action) => {
            state.onboardingData = action?.payload;
            // console.log("ONBOARDING DATA IN THE REDUCER", JSON.stringify(action.payload))
        })
            .addCase(postOnboardingReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postDeleteAccountReducer.fulfilled, (state, action) => {
                state.deleteAccount = action.payload;
            })
            .addCase(postDeleteAccountReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postRevokeAccountReducer.fulfilled, (state, action) => {
                state.revokeAccount = action.payload;
            }).addCase(postRevokeAccountReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(GetEnterpriseCompanyList.fulfilled, (state, action) => {
                state.companies = action.payload;
            }).addCase(GetEnterpriseCompanyList.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postResumePraising.fulfilled, (state, action) => {
               console.log("postResumePraising.fulfilled",state)
            }).addCase(postResumePraising.rejected, (state, action) => {
                console.log("postResumePraising.rejected", state )
            })
            .addCase(getUserIdDetails.fulfilled, (state, action) => {
              state.userTypeDetails = Array.isArray(action.payload)
                ? { data: action.payload }
                : action.payload;
            }).addCase(getUserIdDetails.rejected, (state, action) => {
                console.log("getUserIdDetails.rejected", state )
            })
    }
})

export const { setDeeplinking ,clearOnboarding } = OnboardingSlice.actions;
export default OnboardingSlice.reducer;